<template>
    <div class="sales-qualification">
        <el-form size="mini" label-width="auto">
            <el-form-item label="已有旅游资格数量:">
                {{ travelNumber }}
            </el-form-item>
            <el-form-item label="旅游基金余额:">
                {{ B1 }} W$
            </el-form-item>
            <el-form-item label="购买旅游资格数量: " required>
                <el-input-number v-model="buyNumber" @change="handleChange" :min="0" :max="10"
                    label="购买旅游资格数量"></el-input-number>
            </el-form-item>
            <el-form-item label="需要支付金额:">
                {{ payAmount }} {{ $symbol() }}
            </el-form-item>
            <el-form-item label="请输入支付密码:" required>
                <el-input v-model="payPassWord" type="password" clearable show-password
                    style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm(0)">购 买</el-button>
                <el-button v-if="companyCode === 'MEX'" @click="submitForm(1)">在线支付</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import { getPersonalData2 } from "@/api/rus/api";

export default {
    name: "SalesQualification",
    data() {
        return {
            B1: 0,
            travelNumber: 0,
            buyNumber: 0,
            payAmount: 0,
            payPassWord: "",
            doLoading: false,
            list: [],
            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },
            initDict: {
                paystate: 'sysaftersale.paystate',
            },
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.doLoading = true;
            getPersonalData2({ ...this.listQuery }).then(res => {
                if (res.data && res.data.length > 0) {
                    const resB1Item = res.data.find(item => item.acType === 'B1');
                    this.B1 = resB1Item ? resB1Item.validBalance : 0;
                }
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.doLoading = false;
            });
        },
        handleChange() {
            console.log('handleChange', this.buyNumber);
            if (this.buyNumber == 0) {
                this.payAmount = 0
                return
            }
            let totalAmount = this.buyNumber * 800
            if (this.B1 >= totalAmount) {
                this.payAmount = 0
            } else {
                this.payAmount = (totalAmount - this.B1) * 18
            }
        },
        submitForm() {
            if (this.buyNumber == 0) {
                return
            }
            console.log(this.buyNumber, 'submitForm')
            this.$confirm(
                `您确定要购买 ${this.buyNumber} 个旅游资格吗？`,
                '确认购买',
                {
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: '确 定',
                    cancelButtonText: '取 消'
                }).then(() => {
                    this.$message.success('购买成功！');
                    this.buyNumber = 0;
                    this.payAmount = 0;
                    this.getList();
                }).catch(() => {
                    this.$message.info('已取消购买');
                });

        }
    }


}
</script>

<style lang="scss" scoped>
.sales-qualification {
    text-align: left;
}
</style>